import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

// Create an API thunk for fetching data
export const fetchDataErrors = createApi('pricememo', 'GET');

const DataErrors = createSlice({
  name: 'DataErrors',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataErrors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataErrors.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDataErrors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DataErrors.reducer;